import React, { useEffect, useState, useRef } from "react";

import { io } from "socket.io-client";
import { GoogleMap, Polyline, useJsApiLoader } from "@react-google-maps/api";
import { Button, Modal } from "react-bootstrap";
// import icon from "../../assets/images/map-marker-svgrepo-com.svg";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Polyline,
//   useMap,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";

// const serverUrl = process.env.REACT_APP_SERVER_URL;
// const socket = io(serverUrl, {
//   query: {
//     app_key: "VURA_9Lrrq9xoYI",
//     secret_key: "44BDE3F4213647FE6DBD353A5DF56",
//   },
// });

// const customIcon = new L.Icon({
//   iconUrl: icon,
//   iconSize: [32, 32],
//   iconAnchor: [16, 32],
//   popupAnchor: [0, -32],
// });

const LiveTrack = ({ isOpen, onClose, user, source }) => {
  const [token, setToken] = useState("");
  const [path, setPath] = useState([]);
  const mapRef = useRef(null);
  const polylineRef = useRef(null);

  const [userId, setUserId] = useState(user?.id);
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
  });
  // useEffect(() => {
    // if (!isOpen) return;

  //   socket.on("token", (token_data) => {
  //     setToken(token_data);
  //   });

  //   return () => {
  //     socket.off("token");
  //     socket.off("locationUpdate");
  //   };
  // }, [isOpen]);

  // useEffect(() => {
  //   if (token) {
  //     socket.on("message", (message) => {
  //       if (message.userId === user?.empid) {
  //         setPath((prevPath) => [
  //           ...prevPath,
  //           { lat: parseFloat(message.lat), lng: parseFloat(message.lng) },
  //         ]);
  //       }
  //     });
  //   }
  // }, [token, user?.empid]);

  return (
    <Modal show={isOpen} onHide={onClose} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Live Tracking - {user?.employee_name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "400px" }}
            zoom={15}
            center={
              path.length > 0 ? path[path.length - 1] : { lat: 1.0, lng: 2.0 }
            }
            ref={mapRef}
          >
            <Polyline
              path={path}
              options={{ strokeColor: "#FF0000", strokeWeight: 4 }}
            />
          </GoogleMap>
        ) : (
          <p>Loading Map...</p>
        )}

       
      </Modal.Body>
    </Modal>
  );
};

export default LiveTrack;
